import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import moment from "moment";
import {Radio, Grid, Button, Hidden} from '@material-ui/core';
import DatePicker from 'material-ui-pickers/DatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from "lodash";

import {selectedNotes, fetchNotes, addNewNote,
    editNote, fetchCategories,fetchingData, newNoteAdded,
    clearStationSelection, clearAreaSelection, clearZoneSelection} from "../../../actions/visits_actions";
import ActionButtons from "../common/actionButtons";
import LoadingSpinner from "../../../components/spinner/Spinner";
import EmptyState from "../../../components/emptyState/EmptyState";
import PrioritySelect from "../../../components/prioritySelect/PrioritySelect";
import VerticalAlign from "../../../components/verticalAlign/VerticalAlign";
import CheckIn from "../components/checkIn";

import lowest from "../../../assets/priority/lowest.svg";
import medium from "../../../assets/priority/medium.svg";
import highest from "../../../assets/priority/highest.svg";
import note from './../../../assets/note.png';
import add from './../../../assets/add_button.png';

import './styles.scss';

class Notes extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            showShareModal: false,
            showFilters: false,
            categoriesSelected: [],
            type: '',
            priority: false,
            dueDateGTE: null,
            dueDateLTE: null
        }
    }

    componentDidMount(){
        this.props.fetchCategories();
    }

    handleChangeNote = (ev) => {
        let value = parseInt(ev.target.value, 10);
        let selectedNotes = this.props.visits.selectedNotesIds;

        if (this.props.visits.selectedNotesIds.indexOf(value) > -1) {
            selectedNotes.splice(this.props.visits.selectedNotesIds.indexOf(value), 1);
        }else{
            selectedNotes.push(value);
        }

        this.props.selectedNotes(selectedNotes);
    };

    preventPropagation(e){
        e.stopPropagation();
        e.preventDefault();
    };

    renderNoteRow = () => {

        let notes = this.props.visits.notes;
        let {categoriesSelected, priority, dueDateGTE, dueDateLTE} = this.state;

        // Filter category
        if(categoriesSelected.length > 0){
            notes = notes.filter(note => {
               return categoriesSelected.indexOf(note.category) > -1
            });
        }

        // Filter Priority
        if(priority){
            notes = notes.filter(note => note.priority === priority);
        }

        // Due Date filters
        if(dueDateGTE){
            notes = notes.filter(note => {
                let dueDate = moment(note.due_date).format('YYYY-MM-DD');
                return moment(dueDateGTE).isBefore(dueDate)
            });
        }
        if(dueDateLTE){
            notes = notes.filter(note => {
                let dueDate = moment(note.due_date).format('YYYY-MM-DD');
                return moment(dueDateLTE).isAfter(dueDate)
            });
        }


        if(notes.length === 0){
            return <VerticalAlign><EmptyState text={"No hay notas disponibles"} /></VerticalAlign>;
        }

        return notes.map((note) => {

            let station = this.getSelectedStation(note.station);

            let priorityImgs = {
                high: <img src={highest} alt={'alta'} />,
                medium: <img src={medium} alt={'media'} />,
                low: <img src={lowest} alt={'baja'} />,
            };


                let dueDate = moment(note.due_date).format('YYYY-MM-DD');
                let timeTo = '';
                if(note.due_date){
                   timeTo= moment().to(dueDate);
                    if(moment().isAfter(dueDate)){
                        timeTo = <span>Vencido</span>
                    }
                }else{
                    timeTo='';
                }




            return (
                <div key={note.id.toString()}
                     className={this.props.notes.noteToEdit.id === note.id ? "note-selected" : "note"}
                     onClick={()=>{this.props.editNote(note)}}
                >
                    <Radio
                        checked={this.props.visits.selectedNotesIds.indexOf(note.id) > -1}
                        disableRipple={true}
                        onClick={(ev)=>{this.preventPropagation(ev); this.handleChangeNote(ev)}}
                        value={note.id.toString()}
                        className="radio-button"
                        aria-label="A"
                    />
                    <div className={"note-title"}>{this.props.stations.selectedStation!==0?note.title:
                        `Boca ${station && station.global_code} - ${note.title}`}</div>
                    <div className={"category"} style={{backgroundColor: note.category_color}}>{note.category_display}</div>
                    {note.files.filter(file => file.is_active).length > 0 &&
                    <div className={'note-attachment'}>
                        <FontAwesomeIcon icon="paperclip" color={"#CCCCCC"} size={"lg"} />
                    </div>
                    }
                    <div className={"priority"}>{priorityImgs[note.priority]}</div>
                    <div className={"note-description"}>{note.public_comment}</div>
                    <div className={"time-to-due"}>{timeTo}</div>
                </div>
            );
        })

    };

    showModal = (type) => {
        this.setState({showModal: true, type});
    };


    showShareModal = () => {
        this.setState({showShareModal: true});
    };


    toggleFilter = () => {
        this.setState({showFilters: !this.state.showFilters});
    };


    toggleCategory = (id) => {
        let categoriesSelected = [...this.state.categoriesSelected];
        let index = categoriesSelected.indexOf(id);
        if(index > -1){
            categoriesSelected.splice(index, 1);
        }else{
            categoriesSelected.push(id);
        }
        this.setState({categoriesSelected});
    };

    _clearFilter = () => {
        this.setState({
            dueDateLTE: null,
            dueDateGTE: null,
            priority: false,
            categoriesSelected: []
        });
    };

    getSelectedStation = (station_id) =>{
        return _.find(this.props.stations.list, (station)=>{
            return station.id === station_id
        });
    };

    getSelectedArea = () =>{
        return _.find(this.props.areas.list, (area)=>{
            return area.id === this.props.areas.selectedArea
        });
    };

    getSelectedZone = () =>{
        return _.find(this.props.zones.list, (zone)=>{
            return zone.id === this.props.zones.selectedZone
        });
    };

    clearZoneSelection = () =>{
        this.props.clearZoneSelection();
        this.props.clearAreaSelection();
    };

    render() {
        let { showFilters, categoriesSelected} = this.state;
        let {type}= this.props;
        let station = this.getSelectedStation(this.props.stations.selectedStation);

        let backAction = this.props.clearStationSelection;
        let title = `Boca ${station && station.global_code}`;

        if(this.props.mobile.isMobile && (type==="area"|| type==="zone")){
            backAction = type==="area"?
                this.props.clearAreaSelection: this.clearZoneSelection;
            title= type==="area"?
                `Area ${this.getSelectedArea().name}`:`Zona ${this.getSelectedZone().name}`;
        }


        return (
            <div className={'notes-section'}>
                <Hidden mdUp>
                    <div className={'red-banner text-center'}>
                        <i className="material-icons chevron"
                           onClick={backAction}
                        >
                            chevron_left
                        </i>
                        {title}
                    </div>
                    <CheckIn />
                </Hidden>
                <div className={"notes-title"}>
                    <Grid container spacing={8}>
                        <Grid item xs={6}>
                            <div className={'note-title-container'}>
                                <img src={note} alt={"notes"} className={"icon"}/>
                                <div className={"title-text"}>NOTAS</div>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            {this.props.visits && this.props.visits.selectedNotesIds.length > 0 &&
                            <ActionButtons type={"selected"}/>}
                            {this.props.visits && this.props.visits.selectedNotesIds.length === 0 &&
                            <div className={"categories"}>
                                <div className={"categories-btn"} onClick={this.toggleFilter}>
                                    FILTROS
                                </div>
                            </div>
                            }
                        </Grid>
                    </Grid>
                </div>
                {showFilters &&
                <div className={'filter-container'} onClick={this.toggleFilter}>
                    <div className={'categories-section'} onClick={(ev) => ev.stopPropagation()}>
                        <div>CATEGORIAS</div>
                        {this.props.visits.categories.map((category, index) => {
                            let opacity = categoriesSelected.indexOf(category.id) > -1 ? 1 : 0.3;
                            return (
                                <div className={"category-selector"} key={index}
                                     onClick={() => this.toggleCategory(category.id)}
                                     style={{backgroundColor: category.color, opacity}}>
                                    {category.title}
                                </div>
                            )
                        })}
                    </div>
                    <div className={'date-filter-section'} onClick={(ev) => ev.stopPropagation()}>
                        <Grid container spacing={24}>
                            <Grid item xs={12} md={8}>
                                <div>FECHA VENCIMIENTO</div>
                                <Grid container spacing={8}>
                                    <Grid item xs={6}>
                                        <DatePicker
                                            value={this.state.dueDateGTE}
                                            maxDate={this.state.dueDateLTE}
                                            format={'DD/MM/YYYY'}
                                            cancelLabel={'Cancelar'}
                                            onChange={(dueDateGTE) => this.setState({dueDateGTE})}
                                            className={'date-input-field'}
                                            placeholder={'Desde'}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <DatePicker
                                            value={this.state.dueDateLTE}
                                            minDate={this.state.dueDateGTE}
                                            format={'DD/MM/YYYY'}
                                            cancelLabel={'Cancelar'}
                                            onChange={(dueDateLTE) => this.setState({dueDateLTE})}
                                            className={'date-input-field'}
                                            placeholder={'Hasta'}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item  xs={12} md={4}>
                                <div>PRIORIDAD</div>
                                <PrioritySelect priority={this.state.priority}
                                                changeAction={priority => this.setState({priority})}
                                />
                            </Grid>
                        </Grid>
                    </div>
                    <div className={'clear-filter-section'} onClick={(ev) => ev.stopPropagation()}>
                        <Button onClick={this._clearFilter} className={'clear-button'}>
                            Borrar filtros
                        </Button>
                    </div>
                </div>
                }

                {this.props.visits.notes && !this.props.visits.fetchingData &&
                <div className={'notes-row-section'}>
                    {this.renderNoteRow()}
                </div>
                }

                {!this.props.visits.notes && !this.props.visits.fetchingData &&
                <div className={'notes-row-section'}>
                    <VerticalAlign>
                        <EmptyState text={"No hay notas disponibles"}/>
                    </VerticalAlign>
                </div>
                }

                {((!this.props.visits.notes && this.props.stations.selectedStation!==0) || this.props.visits.fetchingData) &&
                <div className={'notes-row-section'}>
                    <VerticalAlign>
                        <LoadingSpinner className={''} width={50} />
                    </VerticalAlign>
                </div>
                }
                {this.props.stations.selectedStation !== 0 && !this.props.notes.showNewNote &&
                <img src={add} alt={"addnote"} className={"add-icon"} onClick={this.props.addNewNote}/>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        visits: state.visits,
        notes: state.notes_actions,
        stations: state.stations,
        zones: state.zones,
        areas: state.areas,
        mobile: state.mobile
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        selectedNotes, fetchNotes, addNewNote, editNote, newNoteAdded,
        fetchCategories, fetchingData, clearStationSelection, clearZoneSelection, clearAreaSelection}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Notes);


// WEBPACK FOOTER //
// ./src/containers/site-visits/notes/Notes.js